export enum StepStatus {
  NotStarted,
  Started,
  Completed,
  Error
}
